/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
// material react table
import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";
//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";
//import context
import { GlobalProvider } from "context/GlobalContext";
//import translation function for language translation
import { useTranslation } from "react-i18next";

const ProjectList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t } = useTranslation(); //for translation
  const {
    reloadProjectList,
    setreloadProjectList,
    seteditProjectId,
    filterDateRange,
    filterTitle,
    filterTags,
    screenHeight,
  } = useContext(GlobalProvider);
  const [projectList, setProjectList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return projectList.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : projectList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Project.xlsx");
  };

  /* function to get all project data */
  const getAllProjectList = async (currentSearch = search) => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_PROJECTS +
        `?token=${token}&userrolestring=${userInfo.role.name}`;
      requestUrl +=
        filterDateRange != "" ? `&filterdates=${filterDateRange}` : "";
      if (filterTitle != "") {
        requestUrl = requestUrl + `&filtertitle=${filterTitle}`;
      }
      if (filterTags.length > 0) {
        requestUrl = requestUrl + `&filtertags=${filterTags}`;
      }
      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }
      console.log("project list url =====>>>", requestUrl);
      const response = await getData(requestUrl);
      console.log("project list response ========>>>", response);
      if (response.data) {
        setProjectList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <div className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.title}</span>
          <Link
            to="#addUpdateProjectPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                seteditProjectId(dataItem._id);
              }}
            >
              edit
            </span>
          </Link>
        </div>
      </div>
    );
  };

  const tableColumns = useMemo(() => withStrictFilter([
    {
      id: "title",
      accessorKey: "title",
      header: t("Title"),
      Cell: ({ row }) => titleHtml({ dataItem: row.original }),
      size: 200,
    },
    {
      id: "owner",
      accessorKey: "owner",
      header: t("Moderator"),
      size: 200,
    },
    {
      id: "projectstartdate",
      accessorKey: "projectstartdate",
      header: t("Start Date"),
      size: 200,
    },
    {
      id: "projectenddate",
      accessorKey: "projectenddate",
      header: t("End Date"),
      size: 200,
    },
    {
      id: "tagstring",
      accessorKey: "tagstring",
      header: t("Labels"),
      size: 200,
    },
  ]), [projectList]);

  /* filter/search API triggers */
  useEffect(() => {
    if (filterDateRange != "" || filterTitle != "" || filterTags.length > 0) {
      getAllProjectList();
    }
  }, [filterDateRange, filterTitle, filterTags]);

  /* hook to reload list */
  useEffect(() => {
    if (reloadProjectList) {
      getAllProjectList();
      setreloadProjectList(false);
    }
  }, [reloadProjectList]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllProjectList();
    }
  }, [responseReceived]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* global search */
  useEffect(() => {
    getAllProjectList(search);
  }, [search]);

  /* set records when projectList changes */
  useEffect(() => {
    setRecords(projectList.length);
  }, [projectList]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, projectList]);

  return (
    <div className="table-responsive">
      {/* Hidden checkboxes so ProjectHeader deleteProjectHandler can detect selected rows */}
      <div style={{ display: "none" }}>
        {projectList.map((project) => (
          <input
            key={project._id}
            type="checkbox"
            name="selectProjectRecord"
            filtername="selectedrecord"
            value={project._id}
            checked={!!rowSelection[project._id]}
            onChange={() => {}}
          />
        ))}
      </div>
      <MaterialReactTable
        {...defaultTableConfig}
        enableGlobalFilter
        globalFilterFn="strictContains"
        columns={tableColumns}
        data={projectList}
        enableSorting
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        getRowId={(row) => row._id}
        state={{ rowSelection, isLoading }}
        renderLoadingOverlay={() => null}
        muiLinearProgressProps={{ sx: { display: 'none' } }}
        muiCircularProgressProps={{ sx: { display: 'none' } }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
      />
    </div>
  );
};
export default ProjectList;
